import { render, staticRenderFns } from "./PdfarlIndextab3.vue?vue&type=template&id=3ef141a3"
import script from "./PdfarlIndextab3.vue?vue&type=script&lang=js"
export * from "./PdfarlIndextab3.vue?vue&type=script&lang=js"
import style0 from "./PdfarlIndextab3.vue?vue&type=style&index=0&id=3ef141a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports